import ModalInfo from 'components/shared/ModalInfo'
import Text from 'components/shared/Text'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useAppSelector } from 'store/hooks'

interface UpgradeCardModalProps {
    isOpen: boolean
    onLinkClick: () => void
    onButtonClick: () => void
    calendarModalToggle: () => void
}

const UpgradeCardModal = ({
    isOpen,
    onLinkClick,
    onButtonClick,
    calendarModalToggle,
}: UpgradeCardModalProps) => {
    const { formatMessage } = useIntl()
    const { isCalendarModalOpened } = useAppSelector((state) => state.unlimited)

    let timeoutId: ReturnType<typeof setTimeout>

    useEffect(() => {
        if (isOpen) {
            timeoutId = setTimeout(
                () => document.documentElement.classList.add('-modal-open'),
                0
            )
        }
        return () => clearTimeout(timeoutId)
    }, [isCalendarModalOpened])

    return (
        <ModalInfo
            isOpened={isOpen}
            linkLabel={formatMessage({
                id: 'annual.btn.do_not_change',
                defaultMessage: 'Nie zmieniaj',
            })}
            buttonLabel={formatMessage({
                id: 'annual.btn.change_to_plus',
                defaultMessage: 'Zmień na Unlimited+',
            })}
            onButtonClick={onButtonClick}
            onLinkClick={onLinkClick}
            variant="secondary"
            areButtonsMobileColumn
            width={570}
            testIdPrefix="unlimited-upgrade-modal"
        >
            <Text variant="heading3" pb={16}>
                {formatMessage({
                    id: 'annual.modal.upgrade_card_header',
                    defaultMessage: 'Uwolnij się od ograniczeń',
                })}
            </Text>
            <Text variant="body" color="grayscale_900" pb={8}>
                {formatMessage({
                    id: 'annual.modal.upgrade_card_description',
                    defaultMessage:
                        'Z kartą Unlimited możesz korzystać z Suntago w dni robocze. Aby korzystać też w weekendy, święta, wakacje i ferie, wybierz kartę Unlimited+!',
                })}
            </Text>

            <Text
                as="button"
                variant="body"
                color="primary_500"
                isUnderlined
                onClick={() => {
                    calendarModalToggle()
                }}
                data-testid="unlimited-upgrade-modal-button-check-calendar"
            >
                {formatMessage({
                    id: 'annual.modal.upgrade_card_link',
                    defaultMessage: 'Sprawdź kalendarz wejść',
                })}
            </Text>
        </ModalInfo>
    )
}

export default UpgradeCardModal
